import React, { useEffect, useState } from "react";
import { Image as ImageIcon, Loader2 } from "lucide-react";
import { fetchSubscriptionTierImage } from "../../../lib/api";

export function TierImage({ storagePath, alt }) {
    const [src, setSrc] = useState("");
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        let cancelled = false;
        if (!storagePath) {
            setSrc("");
            return;
        }
        setLoading(true);
        fetchSubscriptionTierImage(storagePath)
            .then((d) => {
                if (!cancelled) setSrc(d.data_url || "");
            })
            .catch(() => {
                if (!cancelled) setSrc("");
            })
            .finally(() => {
                if (!cancelled) setLoading(false);
            });
        return () => {
            cancelled = true;
        };
    }, [storagePath]);
    if (loading) {
        return (
            <div className="w-20 h-14 rounded-sm bg-[#0A1128] border border-[#2A3655] flex items-center justify-center">
                <Loader2 className="w-3 h-3 animate-spin text-slate-500" />
            </div>
        );
    }
    if (!src) {
        return (
            <div className="w-20 h-14 rounded-sm bg-[#0A1128] border border-dashed border-[#2A3655] flex items-center justify-center text-slate-600">
                <ImageIcon className="w-4 h-4" />
            </div>
        );
    }
    return (
        <img
            src={src}
            alt={alt || ""}
            className="w-20 h-14 rounded-sm object-cover border border-[#2A3655] bg-[#0A1128]"
        />
    );
}

// ----- Tier editor dialog -----
